import { ReactElement, ReactNode } from 'react';
import { useOutletContext } from 'react-router-dom';

/**
 * Gate for the plot/detail tabs (charts, tyre-plots, breakdown, data table).
 *
 * The config/run list paints from the lightweight phase-1 summary payload, so the
 * full `calculated_data_internal` payload — which carries the heavy per-channel
 * arrays those tabs index — may still be loading when a plot tab mounts. Rather
 * than crash on undefined arrays, hold the tab behind a spinner until the full
 * payload lands. Rendered as the route element so the wrapped tab only mounts once
 * `session` is present (its own hooks then always run — no rules-of-hooks issues).
 */
export default function RequireFullSession({ children }: { children: ReactNode }): ReactElement {
  const { session, isFullPending } = useOutletContext<{ session: any; isFullPending?: boolean }>();
  if (isFullPending || !session) {
    return <div className="cr-p-8 cr-text-center cr-text-gray-500">Loading session data…</div>;
  }
  return <>{children}</>;
}
